import { render, staticRenderFns } from "./HistoryDatasetAsImage.vue?vue&type=template&id=5d92d0ea"
import script from "./HistoryDatasetAsImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoryDatasetAsImage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports